import { ApiRoute } from '../../../constants/apiRoutes/apiRoute.ts';
import { PaginationQueryParams } from '../../../constants/apiRoutes/paginationQueryParams.ts';
import { useGenericCrudListQuery } from './useGenericCrudListQuery.ts';
import { SaleModel } from '../types.ts';

interface UseAuctionListDataParams extends PaginationQueryParams {
  [key: string]: any;
}

export const useAuctionListData = <TParams extends PaginationQueryParams>(
  route: ApiRoute<TParams>,
  queryParameters?: Partial<UseAuctionListDataParams>
) => {
  const { data, isLoading, error } = useGenericCrudListQuery<SaleModel>(route, {
    page: 0,
    pageSize: 1000,
    ...queryParameters
  });

  const items = data?.PagedRows || [];

  return {
    items,
    isLoading,
    error,
    isEmpty: !isLoading && items.length === 0
  };
};
